import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common';
import AsyncSidebarGlobalSettingsProducts from '@atlassian/jira-navigation-apps-sidebar-global-settings-products/src/async';
import { createEntry } from '@atlassian/jira-router';
import { resources as assignCustomRolesResources } from '@atlassian/jira-router-resources-eoc-assign-custom-roles';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation';
import { navigationSidebarGlobalResource } from '@atlassian/jira-router-resources-navigation-sidebar-global';
import { eocAssignCustomRolesRoute } from '@atlassian/jira-router-routes-eoc-assign-custom-roles-routes';
import AssignCustomRoles, { LazyAssignCustomRoles } from './ui/spa/eoc/assign-custom-roles';

export const eocAssignCustomRolesRouteEntry = createEntry(eocAssignCustomRolesRoute, {
	component: AssignCustomRoles,
	layout: globalSettingsLayout,

	navigation: {
		menuId: MENU_ID.SETTINGS,
		sidebar: AsyncSidebarGlobalSettingsProducts,
	},

	resources: [
		...getNavigationResources(),
		...assignCustomRolesResources,
		getConsolidationStateResource(),
		navigationSidebarGlobalResource,
	],

	forPaint: [LazyAtlassianNavigation, LazyAssignCustomRoles],
});
